import '../../styles/globals.css'
function Banner(){
    return (
        <section className="hero">
            <div className="container">
                <h1>Planos de Saúde Hapvida - Cuidando de Você e Sua Família</h1>
                <p>A maior rede própria de hospitais, clínicas e laboratórios do Brasil com atendimento em todo o território nacional.</p>
                <a href="#form" className="btn">Quero meu Plano Agora</a>
            </div>
        </section>
    );
}

export default Banner;